export default __webpack_public_path__ + "static/media/marc-olivier-jodoin-NqOInJ-ttqM-unsplash.a04bce3f.jpg";